import styled from "styled-components";

const AboutStyleWrapper = styled.section`
  padding: 110px 0 0;
  background: #0d102d;

  .about_title {
    font-size: 38px;
    color: #ffffff;
    line-height: 55px;
    margin-bottom: 33px;
    text-transform: capitalize;
    font-weight: 600;
  }

  .about_right_content {
    display: flex;
    justify-content: end;
  }

  .about_left_content {
    padding-right: 20px;

    p {
      margin-bottom: 25px;
    }

    .about_list {
      margin-top: 30px;
      margin-bottom: 30px;
      .about_list_item {
        display: flex;
        align-items: center;
        margin-bottom: 12px;
        svg {
          color: #fff;
          font-size: 16px;
          margin-right: 20px;
        }
        span {
          color: rgba(255, 255, 255);
          font-size: 16px;
          line-height: 26px;
        }
     }
  }

  @media only screen and (max-width: 1199px) {
    .about_left_content {
      p {
        font-size: 14px;
        line-height: 26px;
      }
    }
    .about_title {
      font-size: 38px;
      line-height: 53px;
      margin-bottom: 17px;
    }
  }

  @media only screen and (max-width: 991px) {
    .about_left_content {
      p {
        font-size: 12px;
        line-height: 22px;
        margin-bottom: 10px;
      }
    }
    .about_title {
      font-size: 34px;
      line-height: 45px;
      margin-bottom: 17px;
    }
  }

  @media only screen and (max-width: 767px) {
   .about_left_content {
    padding-right: 0;
   }

   .about_right_content {
     margin-top: 50px;
     justify-content: center;
    }
  }

  
`;

export default AboutStyleWrapper;
